export default {
    find:   { method: 'get',    url: 'faqs' },
    create: { method: 'post',   url: 'faqs'},
    update: { method: 'put',    url: 'faqs/{id}'},
    delete: { method: 'delete', url: 'faqs/{id}'}
}